import * as React from "react";
import { useScreenLoaderManager } from "./ScreenLoaderManager.context";
import { CircularProgress, Container } from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";

const ScreenLoaderManager = () => {
  const { screenLoaderVisible } = useScreenLoaderManager();
  if (!screenLoaderVisible) {
    return null;
  }
  return (
    <Container
      sx={(theme) => ({
        position: "fixed",
        m: 0,
        p: 0,
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        minWidth: "100vw",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: zIndex.tooltip,
      })}
      disableGutters
    >
      <CircularProgress />
    </Container>
  );
};

export { ScreenLoaderManager };
